import * as React from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Maximize } from '@factorialco/f0-react/icons/app'
import { AttendanceCustomPeriodEmployeeItemFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Status {
  label: string
  text: string
  variant: 'positive' | 'neutral' | 'warning'
}

interface EmployeeHeaderProps {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  status: Status
  isDaily: boolean
  onOpenTimesheet: () => void
}

export const EmployeeHeader = ({
  employee,
  status,
  isDaily,
  onOpenTimesheet,
}: EmployeeHeaderProps) => {
  return (
    <ResourceHeader
      avatar={{
        type: 'person',
        firstName: employee?.firstName ?? '',
        lastName: employee?.lastName ?? '',
        src: buildUrl(employee?.access?.avatar),
      }}
      title={employee?.fullName ?? ''}
      description={employee?.referenceContract?.jobTitle ?? ''}
      status={status}
      secondaryActions={[
        {
          label: i18n.t('time_tracking.table_collection.employee_summary.actions.open_timesheet'),
          icon: Maximize,
          onClick: onOpenTimesheet,
        },
      ]}
      metadata={
        isDaily
          ? [
              {
                label: '',
                value: {
                  type: 'text',
                  content: i18n.t('time_tracking.table_collection.employee_summary.forfait_jours'),
                },
              },
            ]
          : []
      }
    />
  )
}
